import { render, staticRenderFns } from "./BiciFormulario.vue?vue&type=template&id=9963020a"
import script from "./BiciFormulario.vue?vue&type=script&lang=js"
export * from "./BiciFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports